/**
 * Purr field — sum of calm, low-pressure cats' contribution.
 *
 * Calm purring lowers the sleeper's restlessness rise rate (§4, §4.10).
 */

import type { CatGameplayState } from './soothing.js';

/** Purr field intensity 0..1 from per-cat purring flags. */
export function computePurrField(catPlay: ReadonlyMap<string, CatGameplayState>): number {
  let purring = 0;
  for (const entry of catPlay.values()) {
    if (entry.leaving) continue;
    if (entry.isPurring) purring += 1;
  }
  if (purring === 0) return 0;
  return Math.min(1, 0.25 + purring * 0.22);
}
